import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { MessService } from '../mess.service';
import moment from 'moment';
import { CellPosition, CellValueChangedEvent, ColDef, GridOptions, TabToNextCellParams } from 'ag-grid-community';
import { event } from 'jquery';

export interface PeriodicElement2 {
  itemName: string;
  openBalance: any;
  // consmedQty: any;
  bfQty: any;
  lunchQty: any;
  snacksQty: any;
  DinnerQty: any;
  ratePerUnit: any;
  totalAmount: any;
  closedBalance: any;
  itemId: any;
}

@Component({
  selector: 'app-messdetails-table',
  templateUrl: './messdetails-table.component.html',
  styleUrls: ['./messdetails-table.component.scss']
})
export class MessdetailsTableComponent implements OnInit {
  @Input() min: any;
  yesterday = new Date();

  @Input() max: any;
  current = new Date();

  @ViewChild('searchInputcampus') searchInputcampus!: ElementRef;
  campusQuery: string = '';
  KitchenType: any = '';
  selectDate: string = '';
  messDate: any;
  allocatedCampusList: any;
  filteredCampusDetails: any;
  selectedBuildingName: any;
  selectedBuildingID: any;
  buildingValue: any;
  quickFilter: string = '';

  MealsType: string = '';



  constructor(private service: MessService, private spinner: NgxSpinnerService, private toast: ToastmessageService,) {
    this.yesterday.setDate(this.yesterday.getDate() - 2);
    this.current.setDate(this.current.getDate() + 0);
  }

  ngOnInit(): void {
    this.allocatedCampus();

    // this.rowData = [
    //   {
    //     itemId: 445,
    //     itemName: 'MILK / PAALU - [L]',
    //     ratePerUnit: 41.5,
    //     openBalance: 1000,
    //     closedBalance: 0.0,
    //     totalAmount: 0.0,
    //     bfQty: 0.0,
    //     lunchQty: 0.0,
    //     snacksQty: 0.0,
    //     DinnerQty: 0.0
    //   },
    //   { itemName: 'Rice', itemId: 1, openBalance: 1000, bfQty: 0, lunchQty: 0, snacksQty: 0, DinnerQty: 0, ratePerUnit: 41.5, totalAmount: 0, closedBalance: 0 },
    //   { itemName: 'Dal', itemId: 2, openBalance: 1000, bfQty: 0, lunchQty: 0, snacksQty: 0, DinnerQty: 0, ratePerUnit: 31.8, totalAmount: 0, closedBalance: 0 },
    //   { itemName: 'Vegetables', itemId: 3, openBalance: 850, bfQty: 0, lunchQty: 0, snacksQty: 0, DinnerQty: 0, ratePerUnit: 40, totalAmount: 0, closedBalance: 0 },
    //   { itemName: 'Rice', itemId: 1, openBalance: 1000, bfQty: 0, lunchQty: 0, snacksQty: 0, DinnerQty: 0, ratePerUnit: 40, totalAmount: 0, closedBalance: 0 },
    //   { itemName: 'Dal', itemId: 2, openBalance: 1000, bfQty: 0, lunchQty: 0, snacksQty: 0, DinnerQty: 0, ratePerUnit: 40, totalAmount: 0, closedBalance: 0 },
    //   { itemName: 'Vegetables', itemId: 3, openBalance: 850, bfQty: 0, lunchQty: 0, snacksQty: 0, DinnerQty: 0, ratePerUnit: 40, totalAmount: 0, closedBalance: 0 },
    //   { itemName: 'Rice', itemId: 1, openBalance: 1000, bfQty: 0, lunchQty: 0, snacksQty: 0, DinnerQty: 0, ratePerUnit: 40, totalAmount: 0, closedBalance: 0 },
    //   { itemName: 'Dal', itemId: 2, openBalance: 1000, bfQty: 0, lunchQty: 0, snacksQty: 0, DinnerQty: 0, ratePerUnit: 40, totalAmount: 0, closedBalance: 0 },
    //   { itemName: 'Vegetables', itemId: 3, openBalance: 850, bfQty: 0, lunchQty: 0, snacksQty: 0, DinnerQty: 0, ratePerUnit: 40, totalAmount: 0, closedBalance: 0 },
    //   { itemName: 'Rice', itemId: 1, openBalance: 1000, bfQty: 0, lunchQty: 0, snacksQty: 0, DinnerQty: 0, ratePerUnit: 40, totalAmount: 0, closedBalance: 0 },
    //   { itemName: 'Dal', itemId: 2, openBalance: 0, bfQty: 0, lunchQty: 0, snacksQty: 0, DinnerQty: 0, ratePerUnit: 40, totalAmount: 0, closedBalance: 0 },
    //   { itemName: 'Vegetables', itemId: 3, openBalance: 850, bfQty: 0, lunchQty: 0, snacksQty: 0, DinnerQty: 0, ratePerUnit: 40, totalAmount: 0, closedBalance: 0 },
    // ];

  }

  allocatedCampus() {
    this.spinner.show();
    this.service.getAllocatedcampus().subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.allocatedCampusList = res;
        console.log('  this.allocatedCampusList', this.allocatedCampusList);
        this.campusQuery = '';
        this.filteredCampusDetails = this.allocatedCampusList;
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    })
  }

  onStockDateChange(event: any) {
    this.selectDate = moment(event.value).format("DD MMM YYYY");
    if (this.selectedBuildingID) {
      this.validationSelected();
    }
    // console.log(' this.selectDate', this.selectDate);
  }

  selectCampus(buildingName: any, buildingId: any): void {
    this.filteredCampusDetails = this.allocatedCampusList;
    this.selectedBuildingName = buildingName;
    this.selectedBuildingID = buildingId;
    this.campusQuery = '';
    if (this.selectDate) {
      this.validationSelected();
    }
  }


  validationSelected() {
    this.spinner.show();
    this.service.getvalidate(this.selectedBuildingID, this.selectDate).subscribe({
      next: (res: any) => {
        if (!res || res == 204) {
          this.spinner.hide();
          return;
        }
        this.ItemList();
        this.spinner.hide();
      },
      error: (err: any) => {
        this.toast.showError(err.error.error_description)
        console.log('err', err.error.error_description);
        this.spinner.hide();
      }
    })
  }

  ItemList() {
    this.spinner.show();
    this.service.getItemList(this.selectedBuildingID, this.selectDate).subscribe({
      next: (res: any) => {
        if (!res || res == 204) {
          this.spinner.hide();
          this.rowData = [];
        }
        this.rowData = res;
        console.log('res', res);
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    })
  }

  focusSearchInput() {
    setTimeout(() => {
      if (this.searchInputcampus) {
        this.searchInputcampus.nativeElement.focus();
      }
    }, 100);
  }

  campusSearch(item: any) {
    this.buildingValue = (item.target as HTMLInputElement).value;
    if (this.buildingValue) {
      this.filteredCampusDetails = this.allocatedCampusList.filter((building: any) =>
        building.buildingName.includes(this.buildingValue) ||
        building.buildingName.toLowerCase().includes(this.buildingValue.toLowerCase())
      );
    } else {
      this.filteredCampusDetails = this.allocatedCampusList;
    }
  }


  onstudentMeals(e: any) {
    console.log(e, 'e');
  }

  onfilterChange(event: any) {
    this.quickFilter = event.target.value;
  }


  colDefs: ColDef[] = [

    {
      field: 'itemName',
      headerName: 'Item Name',
      pinned: 'left',
      width: 150,
      filter: 'agTextColumnFilter',
      cellStyle: { 'text-align': 'left', 'font-size': '16px' },
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        return params.value;

      }
    },

    {
      field: 'openBalance',
      headerName: 'Open Balance',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
      headerClass: 'ag-right-aligned-header',
      valueFormatter: (params) => this.numFmt(params.value),
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        return params.value;
      }
    },
    // break fast //

    {
      field: 'bfQty',
      headerName: 'Breakfast Qty',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      cellRenderer: (params: any) => {
        const input = document.createElement('input');
        input.type = 'text';
        input.value = params.value ?? '';
        input.style.width = '100%';
        input.style.padding = '0px 4px';
        input.style.fontSize = '16px';
        input.style.textAlign = 'right';
        input.style.border = '1px solid #007bff';
        input.style.borderRadius = '4px';

        // Disable if open Balance is zero // 

        if ((params.data.openBalance ?? 0) === 0) {
          input.disabled = true;
          input.style.border = '2px solid red'
          // input.style.backgroundColor = 'rgb(248 220 220)'
        }

        // stop row selection on click
        input.addEventListener('click', (e) => e.stopPropagation());

        // prevent AG Grid from hijacking Tab key
        input.addEventListener('keydown', (e: KeyboardEvent) => {
          if (e.key === 'Tab') {
            e.stopPropagation();
            input.style.border = '2px solid green';
          }

          // Block alphabets
          if (/^[a-zA-Z]$/.test(e.key)) {
            e.preventDefault();
            return;
          }

        });

        // also sanitize pasted values
        // input.addEventListener('input', (e: any) => {
        //   e.target.value = e.target.value.replace(/[^0-9]/g, '');
        // });

        // focus behavior
        input.tabIndex = 0;
        params.eGridCell.tabIndex = -1;
        params.eGridCell.addEventListener('focus', () => input.focus());

        // keep cursor at end
        input.addEventListener('focus', (e: any) => {
          const val = e.target.value;

          setTimeout(() => e.target.setSelectionRange(val.length, val.length));
          // input.style.border = '2px solid green';
        });


        // input.addEventListener('change', (e: any) => {
        //   const val = parseFloat(e.target.value);
        //   const openBal = Number(params.data.openBalance ?? 0);
        //   let isValid = true;

        //   if (isNaN(val)) {
        //     alert('❌ Please enter numbers only');
        //     isValid = false;
        //   } else if (val > openBal) {
        //     alert(`❌ Consumed Qty cannot exceed Open Balance (${openBal})`);
        //     isValid = false;
        //   } else if (val < 0) {
        //     alert('❌ Consumed Qty must be greater than 0');
        //     isValid = false;
        //   }

        //   if (!isValid) {
        //     e.target.value = params.value ?? '';
        //     input.style.border = '2px solid green';
        //     return;
        //   }

        //   if (val) {
        //     // ✅ Update the field value dynamically
        //     params.node.setDataValue(params.colDef.field!, val);

        //     const openBalance = parseFloat(params.data.openBalance ?? 0);

        //     // ✅ Calculate total consumed (sum of all meals)
        //     const breakfast = parseFloat(params.data.bfQty ?? 0);
        //     const lunch = parseFloat(params.data.lunchQty ?? 0);
        //     const snacksQty = parseFloat(params.data.snacksQty ?? 0);
        //     const DinnerQty = parseFloat(params.data.DinnerQty ?? 0);
        //     const totalConsumed = breakfast + lunch + snacksQty + DinnerQty;

        //     // ✅ Update total cost and closing balance
        //     const ratePerUnit = parseFloat(params.data.ratePerUnit ?? 0);
        //     const totalAmount = totalConsumed * ratePerUnit;
        //     const closingBal = openBal - totalConsumed;

        //     params.node.setDataValue('totalAmount', Number(totalAmount.toFixed(2)));
        //     params.node.setDataValue('closedBalance', Number(closingBal.toFixed(2)));

        //     // Refresh the grid row
        //     params.api.refreshCells({ rowNodes: [params.node], force: true });
        //   }
        // });

        input.addEventListener('change', (e: any) => {
          const val = parseFloat(e.target.value);
          const openBal = Number(params.data.openBalance ?? 0);

          // 1️⃣ Validate numeric input
          if (isNaN(val)) {
            alert('❌ Please enter numbers only');
            e.target.value = params.value ?? '';
            return;
          }

          if (val < 0) {
            alert('❌ Consumed Qty must be greater than or equal to 0');
            e.target.value = params.value ?? '';
            return;
          }

          // 2️⃣ Update the value first in grid
          params.node.setDataValue(params.colDef.field!, val);

          // 3️⃣ Recalculate total consumed
          const breakfast = parseFloat(params.data.bfQty ?? 0);
          const lunch = parseFloat(params.data.lunchQty ?? 0);
          const snacksQty = parseFloat(params.data.snacksQty ?? 0);
          const dinnerQty = parseFloat(params.data.DinnerQty ?? 0);
          const totalConsumed = breakfast + lunch + snacksQty + dinnerQty;

          // 4️⃣ Check if exceeds open balance
          if (totalConsumed > openBal) {
            alert(`❌ Total Consumed (${totalConsumed}) cannot exceed Open Balance (${openBal}).`);

            // 👉 Reset the last changed field to 0
            params.node.setDataValue(params.colDef.field!, 0);

            // 👉 Recalculate after resetting (so totals stay correct)
            const updatedBreakfast = parseFloat(params.data.bfQty ?? 0);
            const updatedLunch = parseFloat(params.data.lunchQty ?? 0);
            const updatedSnacks = parseFloat(params.data.snacksQty ?? 0);
            const updatedDinner = parseFloat(params.data.DinnerQty ?? 0);
            const validTotal = updatedBreakfast + updatedLunch + updatedSnacks + updatedDinner;

            const ratePerUnit = parseFloat(params.data.ratePerUnit ?? 0);
            const totalAmount = validTotal * ratePerUnit;
            const closingBal = openBal - validTotal;

            params.node.setDataValue('totalAmount', Number(totalAmount.toFixed(2)));
            params.node.setDataValue('closedBalance', Number(closingBal.toFixed(2)));

            params.api.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }

          // 5️⃣ Valid case → update totals normally
          const ratePerUnit = parseFloat(params.data.ratePerUnit ?? 0);
          const totalAmount = totalConsumed * ratePerUnit;
          const closingBal = openBal - totalConsumed;

          params.node.setDataValue('totalAmount', Number(totalAmount.toFixed(2)));
          params.node.setDataValue('closedBalance', Number(closingBal.toFixed(2)));

          params.api.refreshCells({ rowNodes: [params.node], force: true });
        });


        return input;
      },
      headerClass: 'consumed-qty-cell',
    },

    // lunch //
    {
      field: 'lunchQty',
      headerName: 'Lunch Qty',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      cellRenderer: (params: any) => {
        const input = document.createElement('input');
        input.type = 'text';
        input.value = params.value ?? '';
        input.style.width = '100%';
        input.style.padding = '0px 4px';
        input.style.fontSize = '16px';
        input.style.textAlign = 'right';
        input.style.border = '1px solid #007bff';
        input.style.borderRadius = '4px';

        // Disable if open Balance is zero // 

        if ((params.data.openBalance ?? 0) === 0) {
          input.disabled = true;
          input.style.border = '2px solid red'
          // input.style.backgroundColor = 'rgb(248 220 220)'
        }

        // stop row selection on click
        input.addEventListener('click', (e) => e.stopPropagation());

        // prevent AG Grid from hijacking Tab key
        input.addEventListener('keydown', (e: KeyboardEvent) => {
          if (e.key === 'Tab') {
            input.style.border = '2px solid green';
            e.stopPropagation();
          }

          // Block alphabets
          if (/^[a-zA-Z]$/.test(e.key)) {
            e.preventDefault();
            return;
          }
        });

        // also sanitize pasted values
        // input.addEventListener('input', (e: any) => {
        //   e.target.value = e.target.value.replace(/[^0-9]/g, '');
        // });

        // focus behavior
        input.tabIndex = 0;
        params.eGridCell.tabIndex = -1;
        params.eGridCell.addEventListener('focus', () => input.focus());

        // keep cursor at end
        input.addEventListener('focus', (e: any) => {
          const val = e.target.value;

          setTimeout(() => e.target.setSelectionRange(val.length, val.length));
          // input.style.border = '2px solid green';
        });

        // input.addEventListener('change', (e: any) => {
        //   const val = parseFloat(e.target.value);
        //   const openBal = Number(params.data.openBalance ?? 0);
        //   let isValid = true;

        //   if (isNaN(val)) {
        //     alert('❌ Please enter numbers only');
        //     isValid = false;
        //   } else if (val > openBal) {
        //     alert(`❌ Consumed Qty cannot exceed Open Balance (${openBal})`);
        //     isValid = false;
        //   } else if (val < 0) {
        //     alert('❌ Consumed Qty must be greater than 0');
        //     isValid = false;
        //   }

        //   if (!isValid) {
        //     e.target.value = params.value ?? '';
        //     input.style.border = '2px solid green';
        //     return;
        //   }

        //   if (val >= 0) {
        //     // ✅ Update the field value dynamically
        //     params.node.setDataValue(params.colDef.field!, val);

        //     // ✅ Calculate total consumed (sum of all meals)
        //     const breakfast = parseFloat(params.data.bfQty ?? 0);
        //     const lunch = parseFloat(params.data.lunchQty ?? 0);
        //     const snacksQty = parseFloat(params.data.snacksQty ?? 0);
        //     const DinnerQty = parseFloat(params.data.DinnerQty ?? 0);
        //     const totalConsumed = breakfast + lunch + snacksQty + DinnerQty;

        //     // ✅ Update total cost and closing balance
        //     const ratePerUnit = parseFloat(params.data.ratePerUnit ?? 0);
        //     const totalAmount = totalConsumed * ratePerUnit;
        //     const closingBal = openBal - totalConsumed;

        //     params.node.setDataValue('totalAmount', Number(totalAmount.toFixed(2)));
        //     params.node.setDataValue('closedBalance', Number(closingBal.toFixed(2)));

        //     // Refresh the grid row
        //     params.api.refreshCells({ rowNodes: [params.node], force: true });
        //   }
        // });

        input.addEventListener('change', (e: any) => {
          const val = parseFloat(e.target.value);
          const openBal = Number(params.data.openBalance ?? 0);

          // 1️⃣ Validate numeric input
          if (isNaN(val)) {
            alert('❌ Please enter numbers only');
            e.target.value = params.value ?? '';
            return;
          }

          if (val < 0) {
            alert('❌ Consumed Qty must be greater than or equal to 0');
            e.target.value = params.value ?? '';
            return;
          }

          // 2️⃣ Update the value first in grid
          params.node.setDataValue(params.colDef.field!, val);

          // 3️⃣ Recalculate total consumed
          const breakfast = parseFloat(params.data.bfQty ?? 0);
          const lunch = parseFloat(params.data.lunchQty ?? 0);
          const snacksQty = parseFloat(params.data.snacksQty ?? 0);
          const dinnerQty = parseFloat(params.data.DinnerQty ?? 0);
          const totalConsumed = breakfast + lunch + snacksQty + dinnerQty;

          // 4️⃣ Check if exceeds open balance
          if (totalConsumed > openBal) {
            alert(`❌ Total Consumed (${totalConsumed}) cannot exceed Open Balance (${openBal}).`);

            // 👉 Reset the last changed field to 0
            params.node.setDataValue(params.colDef.field!, 0);

            // 👉 Recalculate after resetting (so totals stay correct)
            const updatedBreakfast = parseFloat(params.data.bfQty ?? 0);
            const updatedLunch = parseFloat(params.data.lunchQty ?? 0);
            const updatedSnacks = parseFloat(params.data.snacksQty ?? 0);
            const updatedDinner = parseFloat(params.data.DinnerQty ?? 0);
            const validTotal = updatedBreakfast + updatedLunch + updatedSnacks + updatedDinner;

            const ratePerUnit = parseFloat(params.data.ratePerUnit ?? 0);
            const totalAmount = validTotal * ratePerUnit;
            const closingBal = openBal - validTotal;

            params.node.setDataValue('totalAmount', Number(totalAmount.toFixed(2)));
            params.node.setDataValue('closedBalance', Number(closingBal.toFixed(2)));

            params.api.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }

          // 5️⃣ Valid case → update totals normally
          const ratePerUnit = parseFloat(params.data.ratePerUnit ?? 0);
          const totalAmount = totalConsumed * ratePerUnit;
          const closingBal = openBal - totalConsumed;

          params.node.setDataValue('totalAmount', Number(totalAmount.toFixed(2)));
          params.node.setDataValue('closedBalance', Number(closingBal.toFixed(2)));

          params.api.refreshCells({ rowNodes: [params.node], force: true });
        });


        return input;
      },
      headerClass: 'consumed-qty-cell',
    },

    // snacksQty //
    {
      field: 'snacksQty',
      headerName: 'snacks Qty',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      cellRenderer: (params: any) => {
        const input = document.createElement('input');
        input.type = 'text';
        input.value = params.value ?? '';
        input.style.width = '100%';
        input.style.padding = '0px 4px';
        input.style.fontSize = '16px';
        input.style.textAlign = 'right';
        input.style.border = '1px solid #007bff';
        input.style.borderRadius = '4px';

        // Disable if open Balance is zero // 

        if ((params.data.openBalance ?? 0) === 0) {
          input.disabled = true;
          input.style.border = '2px solid red'
          // input.style.backgroundColor = 'rgb(248 220 220)'
        }

        // stop row selection on click
        input.addEventListener('click', (e) => e.stopPropagation());

        // prevent AG Grid from hijacking Tab key
        input.addEventListener('keydown', (e: KeyboardEvent) => {
          if (e.key === 'Tab') {
            input.style.border = '2px solid green';
            e.stopPropagation();
          }

          // Block alphabets
          if (/^[a-zA-Z]$/.test(e.key)) {
            e.preventDefault();
            return;
          }
        });

        // also sanitize pasted values
        // input.addEventListener('input', (e: any) => {
        //   e.target.value = e.target.value.replace(/[^0-9]/g, '');
        // });

        // focus behavior
        input.tabIndex = 0;
        params.eGridCell.tabIndex = -1;
        params.eGridCell.addEventListener('focus', () => input.focus());

        // keep cursor at end
        input.addEventListener('focus', (e: any) => {
          const val = e.target.value;

          setTimeout(() => e.target.setSelectionRange(val.length, val.length));
          // input.style.border = '2px solid green';
        });

        // input.addEventListener('change', (e: any) => {
        //   const val = parseFloat(e.target.value);
        //   const openBal = Number(params.data.openBalance ?? 0);
        //   let isValid = true;

        //   if (isNaN(val)) {
        //     alert('❌ Please enter numbers only');
        //     isValid = false;
        //   } else if (val > openBal) {
        //     alert(`❌ Consumed Qty cannot exceed Open Balance (${openBal})`);
        //     isValid = false;
        //   } else if (val < 0) {
        //     alert('❌ Consumed Qty must be greater than 0');
        //     isValid = false;
        //   }

        //   if (!isValid) {
        //     e.target.value = params.value ?? '';
        //     input.style.border = '2px solid green';
        //     return;
        //   }

        //   if (val >= 0) {
        //     // ✅ Update the field value dynamically
        //     params.node.setDataValue(params.colDef.field!, val);

        //     // ✅ Calculate total consumed (sum of all meals)
        //     const breakfast = parseFloat(params.data.bfQty ?? 0);
        //     const lunch = parseFloat(params.data.lunchQty ?? 0);
        //     const snacksQty = parseFloat(params.data.snacksQty ?? 0);
        //     const DinnerQty = parseFloat(params.data.DinnerQty ?? 0);
        //     const totalConsumed = breakfast + lunch + snacksQty + DinnerQty;

        //     // ✅ Update total cost and closing balance
        //     const ratePerUnit = parseFloat(params.data.ratePerUnit ?? 0);
        //     const totalAmount = totalConsumed * ratePerUnit;
        //     const closingBal = openBal - totalConsumed;

        //     params.node.setDataValue('totalAmount', Number(totalAmount.toFixed(2)));
        //     params.node.setDataValue('closedBalance', Number(closingBal.toFixed(2)));

        //     // Refresh the grid row
        //     params.api.refreshCells({ rowNodes: [params.node], force: true });
        //   }
        // });

        input.addEventListener('change', (e: any) => {
          const val = parseFloat(e.target.value);
          const openBal = Number(params.data.openBalance ?? 0);

          // 1️⃣ Validate numeric input
          if (isNaN(val)) {
            alert('❌ Please enter numbers only');
            e.target.value = params.value ?? '';
            return;
          }

          if (val < 0) {
            alert('❌ Consumed Qty must be greater than or equal to 0');
            e.target.value = params.value ?? '';
            return;
          }

          // 2️⃣ Update the value first in grid
          params.node.setDataValue(params.colDef.field!, val);

          // 3️⃣ Recalculate total consumed
          const breakfast = parseFloat(params.data.bfQty ?? 0);
          const lunch = parseFloat(params.data.lunchQty ?? 0);
          const snacksQty = parseFloat(params.data.snacksQty ?? 0);
          const dinnerQty = parseFloat(params.data.DinnerQty ?? 0);
          const totalConsumed = breakfast + lunch + snacksQty + dinnerQty;

          // 4️⃣ Check if exceeds open balance
          if (totalConsumed > openBal) {
            alert(`❌ Total Consumed (${totalConsumed}) cannot exceed Open Balance (${openBal}).`);

            // 👉 Reset the last changed field to 0
            params.node.setDataValue(params.colDef.field!, 0);

            // 👉 Recalculate after resetting (so totals stay correct)
            const updatedBreakfast = parseFloat(params.data.bfQty ?? 0);
            const updatedLunch = parseFloat(params.data.lunchQty ?? 0);
            const updatedSnacks = parseFloat(params.data.snacksQty ?? 0);
            const updatedDinner = parseFloat(params.data.DinnerQty ?? 0);
            const validTotal = updatedBreakfast + updatedLunch + updatedSnacks + updatedDinner;

            const ratePerUnit = parseFloat(params.data.ratePerUnit ?? 0);
            const totalAmount = validTotal * ratePerUnit;
            const closingBal = openBal - validTotal;

            params.node.setDataValue('totalAmount', Number(totalAmount.toFixed(2)));
            params.node.setDataValue('closedBalance', Number(closingBal.toFixed(2)));

            params.api.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }

          // 5️⃣ Valid case → update totals normally
          const ratePerUnit = parseFloat(params.data.ratePerUnit ?? 0);
          const totalAmount = totalConsumed * ratePerUnit;
          const closingBal = openBal - totalConsumed;

          params.node.setDataValue('totalAmount', Number(totalAmount.toFixed(2)));
          params.node.setDataValue('closedBalance', Number(closingBal.toFixed(2)));

          params.api.refreshCells({ rowNodes: [params.node], force: true });
        });

        return input;
      },
      headerClass: 'consumed-qty-cell',
    },
    // DinnerQty //
    {
      field: 'DinnerQty',
      headerName: 'Dinner Qty',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      cellRenderer: (params: any) => {
        const input = document.createElement('input');
        input.type = 'text';
        input.value = params.value ?? '';
        input.style.width = '100%';
        input.style.padding = '0px 4px';
        input.style.fontSize = '16px';
        input.style.textAlign = 'right';
        input.style.border = '1px solid #007bff';
        input.style.borderRadius = '4px';

        // Disable if open Balance is zero // 

        if ((params.data.openBalance ?? 0) === 0) {
          input.disabled = true;
          input.style.border = '2px solid red'
          // input.style.backgroundColor = 'rgb(248 220 220)'
        }

        // stop row selection on click
        input.addEventListener('click', (e) => e.stopPropagation());

        // prevent AG Grid from hijacking Tab key
        input.addEventListener('keydown', (e: KeyboardEvent) => {
          if (e.key === 'Tab') {
            input.style.border = '2px solid green';
            e.stopPropagation();
          }

          // Block alphabets
          if (/^[a-zA-Z]$/.test(e.key)) {
            e.preventDefault();
            return;
          }
        });

        // also sanitize pasted values
        // input.addEventListener('input', (e: any) => {
        //   e.target.value = e.target.value.replace(/[^0-9]/g, '');
        // });

        // focus behavior
        input.tabIndex = 0;
        params.eGridCell.tabIndex = -1;
        params.eGridCell.addEventListener('focus', () => input.focus());

        // keep cursor at end
        input.addEventListener('focus', (e: any) => {
          const val = e.target.value;

          setTimeout(() => e.target.setSelectionRange(val.length, val.length));
          // input.style.border = '2px solid green';
        });


        // input.addEventListener('change', (e: any) => {
        //   const val = parseFloat(e.target.value);
        //   const openBal = Number(params.data.openBalance ?? 0);
        //   let isValid = true;

        //   if (isNaN(val)) {
        //     alert('❌ Please enter numbers only');
        //     isValid = false;
        //   } else if (val > openBal) {
        //     alert(`❌ Consumed Qty cannot exceed Open Balance (${openBal})`);
        //     isValid = false;
        //   } else if (val < 0) {
        //     alert('❌ Consumed Qty must be greater than 0');
        //     isValid = false;
        //   }

        //   if (!isValid) {
        //     e.target.value = params.value ?? '';
        //     input.style.border = '2px solid green';
        //     return;
        //   }

        //   if (val >= 0) {
        //     // ✅ Update the field value dynamically
        //     params.node.setDataValue(params.colDef.field!, val);

        //     // ✅ Calculate total consumed (sum of all meals)
        //     const breakfast = parseFloat(params.data.bfQty ?? 0);
        //     const lunch = parseFloat(params.data.lunchQty ?? 0);
        //     const snacksQty = parseFloat(params.data.snacksQty ?? 0);
        //     const DinnerQty = parseFloat(params.data.DinnerQty ?? 0);
        //     const totalConsumed = breakfast + lunch + snacksQty + DinnerQty;

        //     // ✅ Update total cost and closing balance
        //     const ratePerUnit = parseFloat(params.data.ratePerUnit ?? 0);
        //     const totalAmount = totalConsumed * ratePerUnit;
        //     const closingBal = openBal - totalConsumed;

        //     params.node.setDataValue('totalAmount', Number(totalAmount.toFixed(2)));
        //     params.node.setDataValue('closedBalance', Number(closingBal.toFixed(2)));

        //     // Refresh the grid row
        //     params.api.refreshCells({ rowNodes: [params.node], force: true });
        //   }
        // });


        input.addEventListener('change', (e: any) => {
          const val = parseFloat(e.target.value);
          const openBal = Number(params.data.openBalance ?? 0);

          // 1️⃣ Validate numeric input
          if (isNaN(val)) {
            alert('❌ Please enter numbers only');
            e.target.value = params.value ?? '';
            return;
          }

          if (val < 0) {
            alert('❌ Consumed Qty must be greater than or equal to 0');
            e.target.value = params.value ?? '';
            return;
          }

          // 2️⃣ Update the value first in grid
          params.node.setDataValue(params.colDef.field!, val);

          // 3️⃣ Recalculate total consumed
          const breakfast = parseFloat(params.data.bfQty ?? 0);
          const lunch = parseFloat(params.data.lunchQty ?? 0);
          const snacksQty = parseFloat(params.data.snacksQty ?? 0);
          const dinnerQty = parseFloat(params.data.DinnerQty ?? 0);
          const totalConsumed = breakfast + lunch + snacksQty + dinnerQty;

          // 4️⃣ Check if exceeds open balance
          if (totalConsumed > openBal) {
            alert(`❌ Total Consumed (${totalConsumed}) cannot exceed Open Balance (${openBal}).`);

            // 👉 Reset the last changed field to 0
            params.node.setDataValue(params.colDef.field!, 0);

            // 👉 Recalculate after resetting (so totals stay correct)
            const updatedBreakfast = parseFloat(params.data.bfQty ?? 0);
            const updatedLunch = parseFloat(params.data.lunchQty ?? 0);
            const updatedSnacks = parseFloat(params.data.snacksQty ?? 0);
            const updatedDinner = parseFloat(params.data.DinnerQty ?? 0);
            const validTotal = updatedBreakfast + updatedLunch + updatedSnacks + updatedDinner;

            const ratePerUnit = parseFloat(params.data.ratePerUnit ?? 0);
            const totalAmount = validTotal * ratePerUnit;
            const closingBal = openBal - validTotal;

            params.node.setDataValue('totalAmount', Number(totalAmount.toFixed(2)));
            params.node.setDataValue('closedBalance', Number(closingBal.toFixed(2)));

            params.api.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }

          // 5️⃣ Valid case → update totals normally
          const ratePerUnit = parseFloat(params.data.ratePerUnit ?? 0);
          const totalAmount = totalConsumed * ratePerUnit;
          const closingBal = openBal - totalConsumed;

          params.node.setDataValue('totalAmount', Number(totalAmount.toFixed(2)));
          params.node.setDataValue('closedBalance', Number(closingBal.toFixed(2)));

          params.api.refreshCells({ rowNodes: [params.node], force: true });
        });


        return input;
      },
      headerClass: 'consumed-qty-cell',
    },

    {
      field: 'ratePerUnit',
      headerName: 'Rate',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      cellRenderer: (params: any) => {
        const input = document.createElement('input');
        input.type = 'text';
        input.value = params.value ?? '';
        input.style.width = '100%';
        input.style.padding = '0px 4px';
        input.style.fontSize = '16px';
        input.style.textAlign = 'right';
        input.style.border = '1px solid #007bff';
        input.style.borderRadius = '4px';

        // Disable if open Balance is zero // 
        if ((params.data.openBalance ?? 0) === 0) {
          input.disabled = true;
          input.style.border = '2px solid red'
          // input.style.backgroundColor = 'rgb(248 220 220)'
        }

        // stop row selection on click
        input.addEventListener('click', (e) => e.stopPropagation());

        // prevent AG Grid from hijacking Tab key
        input.addEventListener('keydown', (e: KeyboardEvent) => {
          if (e.key === 'Tab') {
            e.stopPropagation();
          }

          // Block alphabets
          if (/^[a-zA-Z]$/.test(e.key)) {
            e.preventDefault();
            return;
          }

        });

        // also sanitize pasted values
        // input.addEventListener('input', (e: any) => {
        //   e.target.value = e.target.value.replace(/[^0-9]/g, '');
        // });

        // focus behavior
        input.tabIndex = 0;
        params.eGridCell.tabIndex = -1;
        params.eGridCell.addEventListener('focus', () => input.focus());

        // keep cursor at end
        input.addEventListener('focus', (e: any) => {
          const val = e.target.value;
          input.style.border = '2px solid green';
          setTimeout(() => e.target.setSelectionRange(val.length, val.length));
        });



        input.addEventListener('change', (e: any) => {
          const val = parseFloat(e.target.value);
          const openBal = Number(params.data.openBalance ?? 0);
          let isValid = true;

          if (isNaN(val)) {
            alert('❌ Please enter numbers only');
            isValid = false;
          } else if (val > openBal) {
            alert(`❌ Consumed Qty cannot exceed Open Balance (${openBal})`);
            isValid = false;
          } else if (val < 0) {
            alert('❌ Consumed Qty must be greater than 0');
            isValid = false;
          }

          if (!isValid) {
            e.target.value = params.value ?? '';
            input.style.border = '2px solid green';
            return;
          }

          if (val >= 0) {
            // ✅ Update the field value dynamically
            params.node.setDataValue(params.colDef.field!, val);

            // ✅ Calculate total consumed (sum of all meals)
            const breakfast = parseFloat(params.data.bfQty ?? 0);
            const lunch = parseFloat(params.data.lunchQty ?? 0);
            const snacksQty = parseFloat(params.data.snacksQty ?? 0);
            const DinnerQty = parseFloat(params.data.DinnerQty ?? 0);
            const totalConsumed = breakfast + lunch + snacksQty + DinnerQty;

            // ✅ Update total cost and closing balance
            const ratePerUnit = parseFloat(params.data.ratePerUnit ?? 0);
            const totalAmount = totalConsumed * ratePerUnit;
            const closingBal = openBal - totalConsumed;

            params.node.setDataValue('totalAmount', Number(totalAmount.toFixed(2)));
            params.node.setDataValue('closedBalance', Number(closingBal.toFixed(2)));

            // Refresh the grid row
            params.api.refreshCells({ rowNodes: [params.node], force: true });
          }
        });

        return input;
      },

      headerClass: 'consumed-qty-cell',
    },

    {
      field: 'totalAmount',
      headerName: 'Total Cost',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
      headerClass: 'ag-right-aligned-header',
      valueFormatter: (params) => this.numFmt(params.value),
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        return params.value;
      }
    },

    {
      field: 'closedBalance',
      headerName: 'Closed Balance',
      width: 150,
      minWidth: 150,
      maxWidth: 150,
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
      headerClass: 'ag-right-aligned-header',
      valueFormatter: (params) => this.numFmt(params.value),
      suppressKeyboardEvent: (params) => params.event.key === 'Tab',
      cellRenderer: (params: any) => {
        params.eGridCell.tabIndex = -1;
        return params.value;
      }
    },


  ];


  rowData: PeriodicElement2[] = [];

  pinnedTopRowData: PeriodicElement2[] = [];

  defaultColDef: ColDef = {
    flex: 1,
    menuTabs: [],
    suppressHeaderMenuButton: true,
    sortable: true,
    filter: false,
  };

  /**
   * Fires when a cell value changes (only for editable cols: consmedQty, ratePerUnit)
   */

  // onCellValueChanged(event: CellValueChangedEvent<PeriodicElement2>) {
  //   // trigger recalculation only when these fields change
  //   if (
  //     event.colDef.field === 'bfQty' ||
  //     event.colDef.field === 'lunchQty' ||
  //     event.colDef.field === 'snacksQty' ||
  //     event.colDef.field === 'DinnerQty' ||
  //     event.colDef.field === 'ratePerUnit'
  //   ) {
  //     // safely get numeric values (default 0)
  //     const breakfast = parseFloat(event.data?.bfQty ?? 0);
  //     const lunch = parseFloat(event.data?.lunchQty ?? 0);
  //     const snacksQty = parseFloat(event.data?.snacksQty ?? 0);
  //     const DinnerQty = parseFloat(event.data?.DinnerQty ?? 0);
  //     const ratePerUnit = parseFloat(event.data?.ratePerUnit ?? 0);

  //     const openBal = Number(event.data?.openBalance ?? 0);

  //     // calculate total consumed qty
  //     const totalConsumed = breakfast + lunch + snacksQty + DinnerQty;

  //     if (totalConsumed > openBal) {
  //       alert(`❌ Total consumed (${totalConsumed}) cannot exceed Open Balance (${openBal})`);
  //       event.node.setDataValue(event.colDef.field!, 0);
  //       return;
  //     }

  //     // calculate total cost
  //     const totalAmount = totalConsumed * ratePerUnit;

  //     // calculate closing balance
  //     const closedBalance = openBal - totalConsumed;

  //     // update grid data
  //     event.node.setDataValue('totalAmount', totalAmount.toFixed(2));
  //     event.node.setDataValue('closedBalance', closedBalance.toFixed(2));

  //     // refresh UI
  //     event.api.refreshCells({ rowNodes: [event.node], force: true });

  //     console.log(`✅ Updated: TotalConsumed=${totalConsumed}, totalAmount=${totalAmount}, closedBalance=${closedBalance}`);
  //   }
  // }

  onCellValueChanged(event: CellValueChangedEvent<PeriodicElement2>) {
    const editableFields = ['bfQty', 'lunchQty', 'snacksQty', 'DinnerQty', 'ratePerUnit'];
    if (!editableFields.includes(event.colDef.field!)) return;

    const openBal = Number(event.data?.openBalance ?? 0);
    const ratePerUnit = Number(event.data?.ratePerUnit ?? 0);

    // Get all entered quantities
    const breakfast = Number(event.data?.bfQty ?? 0);
    const lunch = Number(event.data?.lunchQty ?? 0);
    const snacks = Number(event.data?.snacksQty ?? 0);
    const dinner = Number(event.data?.DinnerQty ?? 0);

    const totalConsumed = breakfast + lunch + snacks + dinner;

    // 🚨 If totalConsumed exceeds openBalance, show alert but continue
    if (totalConsumed > openBal) {
      alert(`⚠️ Warning: Total Consumed (${totalConsumed}) exceeds Open Balance (${openBal}).`);
      return;
    }

    // ✅ Calculate totals regardless
    const totalAmount = totalConsumed * ratePerUnit;
    const closedBalance = openBal - totalConsumed;

    // Update the calculated fields
    event.node.setDataValue('totalAmount', totalAmount.toFixed(2));
    event.node.setDataValue('closedBalance', closedBalance.toFixed(2));

    // Refresh UI
    event.api.refreshCells({ rowNodes: [event.node], force: true });

    console.log(
      `✅ Updated | totalConsumed=${totalConsumed}, totalAmount=${totalAmount}, closedBalance=${closedBalance}`
    );
  }

  /**
   * Utility: formats numbers without decimals
   */
  numFmt(value: any): string {
    if (value === null || value === undefined || value === '') return '';
    const n = Number(value);
    if (isNaN(n)) return '';
    return n.toString(); // plain integer
  }
  // 👉 GRID OPTIONS to control tabbing

  preparePayload() {
    const payload = {
      buildingId: this.selectedBuildingID,
      inventoryDate: this.selectDate ? moment(this.selectDate).format("DD MMM YYYY") : '',
      saveInventoryBalanceDetails: this.rowData.map((item: any) => ({
        itemId: item.itemId,
        ratePerUnit: item.ratePerUnit ? Number(item.ratePerUnit) * -1 : 0,
        bfQty: item.bfQty ? Number(item.bfQty) * -1 : 0,
        lunchQty: item.lunchQty ? Number(item.lunchQty) * -1 : 0,
        snacksQty: item.snacksQty ? Number(item.snacksQty) * -1 : 0,
        DinnerQty: item.DinnerQty ? Number(item.DinnerQty) * -1 : 0,
      }))
    };

    return payload;
  }

  submit() {
    const payload = this.preparePayload();
    this.spinner.show();
    this.service.postMessInventory(payload).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return
        }
        this.toast.showSuccess(res.message);
        console.log('res', res);
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    })
    // console.log('✅ Sending payload:', payload);
  }

}
